@if (disruptions()) {
  @for (item of getMappedDisruptions(); track item.id) {
    @if (!item.hidden) {
      @if (isGlobalBanner() && isNewBrand()) {
        <fcom-banner
          [theme]="item.level"
          [linkText]="item.linkText || (item.linkUrl ? ('readMore' | finLocalization) : null)"
          [linkUrl]="item.linkUrl"
          [title]="item.title"
          [horizontal]="true"
          [isClosable]="isGlobalBanner() ? showGlobalBannerClose(item) : true"
          (linkClick)="onLinkClick($event, item)"
          (closeClick)="onClose(item)"
        >
          @if (item.text) {
            <div [innerHTML]="item.text | resolveLinks | finSafe: 'html'"></div>
          }
        </fcom-banner>
      } @else {
        <fcom-notification
          [class.col-1-12]="!isGlobalBanner() && isNewBrand()"
          [class.ms-xsmall-t]="isNewBrand() && !$first"
          [class.border-bottom]="!isNewBrand() || layout() === NotificationLayout.EDGE_TO_EDGE"
          [layout]="isNewBrand() ? layout() : NotificationLayout.EDGE_TO_EDGE"
          [theme]="item.level"
          [title]="item.title"
          [horizontal]="item.horizontal"
          [linkText]="item.linkText || (item.linkUrl ? ('readMore' | finLocalization) : null)"
          [linkUrl]="item.linkUrl"
          [isClosable]="isGlobalBanner() ? showGlobalBannerClose(item) : true"
          (linkClick)="onLinkClick($event, item)"
          (closeClick)="onClose(item)"
        >
          @if (item.text) {
            <div [innerHTML]="item.text | resolveLinks | finSafe: 'html'"></div>
          }
        </fcom-notification>
      }
    }
  }
}
